import LTR from "@brand-icons/ploom/hand-dobble/hand-dobble-ltr.svg";
import RTL from "@brand-icons/ploom/hand-dobble/hand-dobble-rtl.svg";

import { iconFactory } from "../iconFactory";

export const HandDobbleIcon = iconFactory("HandDobbleIcon", LTR, RTL);
